import { Tag } from "antd";

export const roleOptions = [
  { value: 2, label: "Manager" },
  { value: 3, label: "Employee" },
];

export const PIE_CHART_CONFIG = [
  {
    title: "Completed",
    key: "completedOnTimeCourses",
    color: "rgba(121, 214, 132, 1)",
    bg: "rgba(238, 255, 240, 1)",
  },
  {
    title: "Completed Late",
    key: "lateCompletionCourses",
    color: "rgba(255, 180, 0, 1)",
    bg: "rgba(255, 248, 199, 1)",
  },
  {
    title: "In Progress",
    key: "inProgressCourses",
    color: "rgba(2, 93, 222, 1)",
    bg: "rgba(232, 241, 255, 1)",
  },
  {
    title: "Not Started",
    key: "notStartedCourses",
    color: "rgba(242, 128, 128, 1)",
    bg: "rgba(249, 243, 243, 1)",
  },
  {
    title: "Completion Failed",
    key: "completionFailedCourses",
    color: "rgba(200, 82, 100, 1)",
    bg: "rgba(255, 238, 238, 1)",
  },
  {
    title: "Defaulters",
    key: "defaulterCourses",
    color: "rgba(120, 80, 200, 1)",
    bg: "rgba(240, 232, 255, 1)",
  },
];

export const STATUS_STYLES = {
  Completed: {
    color: "#066710",
    background: "#EEFFF0",
    borderColor: "#95DE9D",
  },
  "In Progress": {
    color: "#C77A00",
    background: "#FFF8C7",
    borderColor: "#FBDC94",
  },
  default: {
    color: "#C80000",
    background: "#FFEEEE",
    borderColor: "#FFAAAA",
  },
};

export const renderStatus = (status) => {
  const { color, background, borderColor } =
    STATUS_STYLES[status] ?? STATUS_STYLES.default;

  return (
    <Tag
      style={{
        padding: "10px 16px",
        borderRadius: "10px",
        border: "1px solid",
        color,
        fontWeight: "500",
        borderColor,
        backgroundColor: background,
      }}
    >
      {status}
    </Tag>
  );
};

export const STATUS_MAP = {
  COMPLETED: "Completed",
  IN_PROGRESS: "In Progress",
  PENDING: "Pending",
  "Not Started": "Not Started",
  "In Progress": "In Progress",
  Completed: "Completed",
};

export const STATUS_OPTIONS = ["Completed", "In Progress", "Not Started"];

export const SUB_TYPE_OPTIONS = [
  { value: "ALL", label: "All" },
  { value: "COURSE", label: "Individual Courses" },
  { value: "BUNDLE", label: "Curriculums" },
];


export const SUB_TYPE_OPTIONS_CURRICULUM = [
  { value: "USER", label: "User"},
  { value: "GROUP", label: "Group" },
];



export const formatDate = (val) => (val ? new Date(val).toLocaleDateString() : "-");

export const getUniqueValues = (data, sourceFilter, field) => [
  ...new Set(
    data
      .filter((e) => e.enrollmentSource === sourceFilter)
      .map((e) => e[field]),
  ),
];

export const mapGroupOptions = (groups = []) =>
  groups.map((g) => ({ label: g.name, value: g.id }));

export const mapUserOptions = (users = []) =>
  users.map((u) => ({ label: u.name, value: u.id }));

export const bundleId = "bundleId";
export const desc ="desc";